/**
 * XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX
 *
 * THIS FILE IS MANAGED CENTRALLY BY THE `common-code` REPO.
 * IT COULD BE AUTO-REPLACED AT ANY TIME.
 * DO NOT MAKE CUSTOM CHANGES TO THIS FILE.
 * @see https://gitlab.com/dea-aero/development/common-code
 *
 * XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX XXX
 */
import {useAppConfigStore} from "../../useAppConfigStore";
import Box from "@mui/material/Box";


export default function ClassificationBar() {
    const classification = useAppConfigStore(state => state.classification);

    if (!classification) return ''

    return <Box sx={{
        zIndex: 10000000,
        px: 4,
        fontWeight: 'bold',
        textAlign: 'center',
        borderBottom: '1px solid black',
        color: '#000',
        backgroundColor: '#fa0'
    }}
    >{classification}</Box>
}
